import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from 'core'
import createStore from 'core/store'
import { history, createLocationUpdater } from 'browser-location'
import { pspVerificationResponse, secure3dResponse, cancelSecure3d } from 'credit-cards/actions'
import featureToggles from 'shared/featureToggles'
const { store, persistor } = createStore()

history.listen(createLocationUpdater(store))

window.notifyOfIngenicoResponse = (details, errors) => store.dispatch(pspVerificationResponse(details, errors))
window.notifyOfSecure3DResponse = (details, errors) => store.dispatch(secure3dResponse(details, errors))
window.notifyOfSecure3DClosed = () => store.dispatch(cancelSecure3d())

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

const renderApp = () => {
    root.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <HelmetProvider>
                    <App history={history} />
                </HelmetProvider>
            </PersistGate>
        </Provider>
    )
}

renderApp()

if (featureToggles.hasHotModuleReplacement) {
    if (module.hot) {
        module.hot.accept('./core', () => {
            renderApp()
        })

        module.hot.accept('./core/store', () => {
            renderApp()
        })
    }
}

if ('fetch' in window && 'Intl' in window) {
    renderApp()
} else {
    import('./polyfills').renderApp(root)
}

if (window.AWS_WAF_INTEGRATION) {
    const script = document.createElement('script')
    script.src = `${window.AWS_WAF_INTEGRATION}challenge.js`
    script.type = 'text/javascript'
    script.defer = true
    document.head.appendChild(script)
}

if (!document.getElementById('pagseguro-sdk') && window.PAYMENT_SERVICE_PROVIDER === 'PAGSEGURO') {
    const script = document.createElement('script')
    script.src = 'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js'
    script.id = 'pagseguro-sdk'
    script.async = true

    document.head.appendChild(script)
}

if (!document.getElementById('nuvei-sdk') && window.PAYMENT_SERVICE_PROVIDER === 'NUVEI') {
    const script = document.createElement('script')
    script.src = 'https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js'
    script.id = 'nuvei-sdk'
    script.async = true

    document.head.appendChild(script)
}

if (window.LINKEDIN_PARTNER_ID) {
    window._linkedin_partner_id = window.LINKEDIN_PARTNER_ID
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id)

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.text = `
        (function(l) {
            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
            window.lintrk.q=[]}
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })(window.lintrk);
    `
    document.head.appendChild(script)
}
